export default "__VITE_ASSET__DbeShOMu__"